<template>
  <div class="story-content-part story-content-part--default" v-html="text" />
</template>

<script>
export default {
  name: 'StoryDescriptionTextPart',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
